(function() {

    var globals = require("./globals.js")

    module.exports = {
        phoneScript: phoneScript,
    }

    var interval;
    var current_sub = 0;
    var sub_opacity = 1;
    var moving = false;
    var scroll_pos = 0;

    function phoneScript(mode) {
        audio = document.getElementById('phoneline-intro');
        track = audio.textTracks[0];
        track.mode = "hidden";
        //      add_transcript(track);
        track.oncuechange = function() {
            cue = this.activeCues[0];
//	for (var j = 0; j < track.cues.length; ++j) {
//	    cue = track.cues[j];
            // do somethin

            if(cue.text != "") {
                current_sub = current_sub + 1;
                $("#telephone-subtitles-container").append("<p class='big-subtitle' id='sub-"+String(current_sub)+"' style='opacity:"+String(sub_opacity)+";'><a></a></p>");
                /*	    if(audio.currentTime>7) {
                        sub_opacity = sub_opacity - 0.1;
                }
                if(moving == false && audio.currentTime>11) {
                moving = true
                $("#telephone-subtitles-container").animate({top:'-130%'}, 15000, function() {
                })
                } */
                sub_pos = $("#sub-"+String(current_sub)).offset().top - $("#telephone-subtitles-container").scrollTop();
                target = $(window).height() - ($(window).height()/2.5) ;
                if(sub_pos >target) {
                    scroll_pos = scroll_pos - (sub_pos - target);
                    $("#telephone-subtitles-container").animate({top:scroll_pos+'px'}, 1000)
                }
                subtitle = cue.text;
                word_list = subtitle.split(" ");
                start = cue.startTime;
                end = cue.endTime;
                length = (end - start)*1000;
                intVal = length / (word_list.length);
                i = 1;
                $("#sub-"+String(current_sub)+" a").append(word_list[0]+" ");
                clearInterval(interval);
                interval = setInterval(function() {
                    if(i<=(word_list.length - 1)) {
                        $("#sub-"+String(current_sub)+" a").append(word_list[i]+" ");
                        i = i +1;
                    };
                }, intVal)
//	    $("#telephone-subtitles-container").append("<p class='big-subtitle'>"+subtitle+"</p>");
                //

            }
            //	    center_subtitle();
        };
        if(!mode) {
            audio.onended = function () {
                setTimeout(function() {
                    $(".big-subtitle, #phoneline-vid").fadeOut(1000, function () {
                        window.location.replace('#/' + globals.lang + '/home');
                    });
                },700)
            }
        }
    }

})();